export const freezeSnapshot = <T>(value: T): T => {
  const copy = structuredClone(value);
  const freeze = (item: unknown) => {
    if (!item || typeof item !== "object" || Object.isFrozen(item)) return;
    Object.values(item).forEach(freeze);
    Object.freeze(item);
  };
  freeze(copy);
  return copy;
};
